module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.d8de52e6.ttf";